import React, { useState, useEffect } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { useForm } from "react-hook-form";

import { ActivationPageWrapper } from "../activation/activationPage.styled";

import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewEAdminReq,
  get_eAdminListReq,
} from "../../api/eAdmin/eAdminReq";
import { SagaActions } from "../../redux/actionTypes";
import { getCEPsListReq } from "../../api/cep/cepAdminRequest";
import RenderIf from "../../components/renderIf";
import TextInputLayout from "../../components/compLayouts/textInputLayout";
import { validate } from "../../constants/validationExp";
import MobileNoLayout from "../../components/compLayouts/mobileNoLayout";
// import RecentAdminTable from "./components/recentAdminTable";
import dayjs from "dayjs";
import { getPlansListReq } from "../../api/activation/plansReq";
import { RootState } from "../../redux/store";
import { COUNTRY_CODES } from "../../constants/countryCodes";
import mailIcon from "../../assets/svgIcons/mail-icon.svg";
import phoneIcon from "../../assets/svgIcons/telephone-icon.svg";
import {
  deleteUserDetailsReq,
  fetchUserDetailsReq,
} from "../../api/user/deleteUserReq";
import { CandidateDetailsType } from "../../types/userTypes";

type Inputs = {
  countryCodeIs: string;
  mobileNumberIs: string;
  emailIs: string;
};

export const DeleteUserPage = () => {
  const Dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<Inputs>();
  const phNo = watch("mobileNumberIs");
  const _numberError = errors.mobileNumberIs?.message;
  const { plans } = useSelector((_state: RootState) => _state);

  const _planList = plans?.data || [];
  const [recentInvitedEAdmins, setrecentInvitedEAdmins] = useState([]);
  const [candDetails, setcandDetails] = useState<CandidateDetailsType[]>([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>("+91");
  const [selectedTimeZone, setSelectedTimeZone] =
    useState<string>("India (GMT+5:30)");

  const handleCountryCodeChange = (e: any) => {
    const selectedCountryCode = e.countryCode;
    const selectedCountry = COUNTRY_CODES.find(
      (country) => country.countryCode === selectedCountryCode
    );
    if (selectedCountry) {
      setSelectedCountryCode(selectedCountry.countryCode);
      setSelectedTimeZone(selectedCountry.countryTimeZone[0].zone);
    }
  };

  const handleTimeZoneChange = (e: any) => {
    setSelectedTimeZone(e.target.value);
  };

  const fetchUserDetailsFun = async (data: Inputs) => {
    try {
      const _data = {
        mobileNumber: data?.mobileNumberIs,
        email: data?.emailIs,
        PhoneCountryCode: Number(selectedCountryCode),
      };
      const res = await fetchUserDetailsReq(_data);
      // Wrap single user object in array for setcandDetails
      setcandDetails(res?.data ? [res.data] : []);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "deleteUserPage",
          methodName: "fetchUserDetailsFun",
          type: "info",
        },
      });
      reset();
    } catch (error: any) {
      toast.error(
        error?.errorMsg
      );
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "deleteUserPage",
          methodName: "fetchUserDetailsFun",
          type: "error",
        },
      });
    }
  };

  const deleteUserDetailsFun = async (item: any) => {
    console.log("item", item);
    try {
      const _data = {
        mobileNumber: item?.mobileNumber || "",
        email: item?.email || "",
        PhoneCountryCode: Number(item?.PhoneCountryCode),
      };
      const res = await deleteUserDetailsReq(_data);
      //   setcepPatnerList(res?.data || []);
      toast.success(res.message);
      setcandDetails([]);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "candidateExpPatnerPage",
          methodName: "fetchCEPlistfun",
          type: "info",
        },
      });
    } catch (error: any) {
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "candidateExpPatnerPage",
          methodName: "fetchCEPlistfun",
          type: "error",
        },
      });
    }
  };

  const handleButtonClick = ({ key, data }: { key: string; data?: any }) => {
    const btnFun: any = {
      createCep: (data: Inputs) => fetchUserDetailsFun(data),
    };
    btnFun[key](data);
  };

  useEffect(() => {
    Dispatch({ type: SagaActions.GET_PLANS });
  }, []);

  return (
    <ActivationPageWrapper className="p-2 h-100">
      <div className="">
        <div className="p-2 mx-2">
          <form
            className="w-100 p-2"
            onSubmit={handleSubmit((data) => {
              handleButtonClick({ key: "createCep", data });
            })}
          >
            <p className="my-1 lg-text">
              <strong>Delete A User</strong>
            </p>
            <div className="p-2"></div>
            <div className="mx-1 bg-white py-3 p-2 rounded shadow-block row">
              <strong>Step 1: Find the user</strong>
              <div className="p-2"></div>
              <div className="col-lg-4 col-md-6">
                <TextInputLayout
                  isError={errors.emailIs?.message}
                  label={"Email"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("emailIs", {
                      required: "Please enter Email",
                      pattern: {
                        value: validate.email,
                        message: "Entered incorrect email format",
                      },
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className="col-lg-5 col-md-6">
                <MobileNoLayout
                  isError={_numberError}
                  mobileNumber={phNo}
                  required
                  onCountryCodeChange={handleCountryCodeChange}
                  // countryCodeOptions={COUNTRY_CODES}
                  selectedCountryCode={selectedCountryCode}
                >
                  <input
                    className={`flex-grow-1 `}
                    placeholder=""
                    type="tel"
                    maxLength={10}
                    {...register("mobileNumberIs", {
                      required: "Enter 10 digit mobile number",
                      maxLength: {
                        value: 10,
                        message: "Enter 10 digit mobile number",
                      },
                      minLength: {
                        value: 10,
                        message: "Enter 10 digit mobile number",
                      },
                      pattern: {
                        value: validate.phone,
                        message: "Incorrect mobile number",
                      },
                    })}
                  />
                </MobileNoLayout>
              </div>
              <div className=" col-lg-3 col-md-4 d-flex flex-column justify-content-end p-2">
                <button
                  type="submit"
                  className="btn primary-bg text-white w-100"
                >
                  Search Candidate
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="w-100 p-2">
        <div className="shadow-block bg-white p-3 mx-3 m-2 rounded">
          <strong>Step 2: User Details</strong>
          <div className="p-1"></div>
          {candDetails.map((item, index) => (
            <div className="d-flex flex-row align-items-center p-2">
              <div className="col-lg-4 col-md-6">
                <p className={`lg-text`}>
                  {
                    item?.candidateName
                    }
                </p>
                <div className={`d-flex align-items-center`}>
                  <div className="me-1">
                    <img src={phoneIcon} />
                  </div>
                  <p className={`md-text`}>
                    {item?.mobileNumber}
                  </p>
                </div>
                <div className={`d-flex align-items-center`}>
                  <div className="me-1">
                    <img src={mailIcon} />
                  </div>
                  <p className={`md-text`}>
                    {item?.email}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <strong className="d-flex flex-row">
                  Created On:{" "}
                  <p className={`md-text ms-1`}>{item?.offers?.[0]?.createdAt}</p>
                </strong>
                <strong className="d-flex flex-row">
                  Company:{" "}
                  <p className={`md-text ms-1`}>{item?.companyName}</p>
                </strong>
                {/* <strong className="d-flex flex-row">
                  Current Status:{" "}
                  <p className={`md-text ms-1`}>{item?.offers?.[0]?.offerStatus}</p>
                </strong> */}
                <strong className="d-flex flex-row">
                  User Type:{" "}
                  <p className={`md-text ms-1`}>{item?.userType}</p>
                </strong>
              </div>
              <div className="w-25 col-lg-3 col-md-4 d-flex flex-column justify-content-start p-2">
                <button
                  className="btn primary-bg text-white w-100"
                  onClick={() => deleteUserDetailsFun(item)}
                >
                  Delete Account
                </button>
              </div>
            </div>
          ))}
          {candDetails?.length <= 0 && 
          <div className="d-flex justify-content-center align-items-center ">
            <p className={`md-text`}>No User Details</p>
          </div>
          }
        </div>
      </div>
    </ActivationPageWrapper>
  );
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  input {
    border: none;
    outline: none;
    padding: 0px 10px;
  }
  .input_box {
    display: flex;
    align-items: center;
    border-radius: 8px;
    height: 35px;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid rgb(216, 216, 216);
  }
  .icon_box {
    height: 25px;
    width: 25px;
    border: 0px solid;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .image_icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 0px solid;
  }
  .country_code_box {
    /* width: 100px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    height: 45px;
    border: 1px solid rgb(200, 200, 200);
  }
`;
